module.exports = {
    toggleCollapse: function (element, expand) {
        var collapsible = element.closest('.collapsible');
        collapsible.toggleClass('active', expand);

        if (collapsible.hasClass('active')) {
            element.attr('aria-expanded', true);
        } else {
            element.attr('aria-expanded', false);
        }
    }
}